module.exports = __webpack_public_path__ + "static/media/negro.c89c406f.svg";